// REDCARE — JS de las secciones personalizadas (prefijo rc-)
document.documentElement.classList.add('rc-js-ready');

document.addEventListener('DOMContentLoaded', function () {
  initRcReveal();
  initRcStickyBar();
  initRcGallery();
  initRcTiers();
  initRcViewers();
});

function initRcReveal() {
  var items = document.querySelectorAll('.rc-reveal');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) { el.classList.add('rc-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('rc-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  items.forEach(function (el) { observer.observe(el); });

  // Red de seguridad: si algo impide que el observador dispare (pestaña en
  // segundo plano al cargar, fuente tardía, etc.), no dejamos contenido
  // invisible para siempre.
  setTimeout(function () {
    items.forEach(function (el) { el.classList.add('rc-visible'); });
  }, 2500);
}

function initRcStickyBar() {
  var bar = document.querySelector('[data-rc-stickybar]');
  if (!bar) return;
  var watchSelector = bar.getAttribute('data-rc-watch');
  var watchTarget = watchSelector ? document.querySelector(watchSelector) : null;
  if (!watchTarget) return;

  function update() {
    var pastHero = watchTarget.getBoundingClientRect().bottom < 0;
    bar.classList.toggle('rc-stickybar--visible', pastHero);
    document.body.classList.toggle('rc-stickybar-active', pastHero);
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
}

function initRcGallery() {
  var galleries = document.querySelectorAll('[data-rc-gallery]');
  galleries.forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-rc-main-img]');
    var thumbs = gallery.querySelectorAll('[data-rc-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-rc-full');
        var alt = thumb.getAttribute('data-rc-alt') || '';
        if (!full) return;
        mainImg.setAttribute('src', full);
        mainImg.setAttribute('alt', alt);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

function initRcViewers() {
  var els = document.querySelectorAll('[data-rc-viewers]');
  if (!els.length) return;
  els.forEach(function (el) {
    var base = parseInt(el.getAttribute('data-rc-viewers'), 10) || 40;
    var span = el.querySelector('[data-rc-viewers-count]') || el;
    function tick() {
      var val = base + Math.floor(Math.random() * 25);
      span.textContent = val;
    }
    tick();
    setInterval(tick, 5000);
  });
}

function initRcTiers() {
  var groups = document.querySelectorAll('[data-rc-tiers]');
  groups.forEach(function (group) {
    var tiers = group.querySelectorAll('[data-rc-tier]');
    var groupId = group.getAttribute('data-rc-qty-group');
    var qtyInputs = groupId ? document.querySelectorAll('[data-rc-qty-mirror="' + groupId + '"]') : [];
    if (!tiers.length || !qtyInputs.length) return;

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        var qty = tier.getAttribute('data-rc-tier');
        qtyInputs.forEach(function (input) { input.value = qty; });
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tier.classList.add('is-selected');
      });
    });
  });
}
